export default __webpack_public_path__ + "src/assets/coinmarketcap.44ee673de8ee9f6e1290780fefe78013.svg";